"use client";

import React from "react";
import Image from "next/image";
import styles from "./ServicesPortfolio.module.css";

interface ServiceItem {
  icon: string;
  title: string;
  desc: string;
}

interface ServicesPortfolioProps {
  heading: string;
  subheading: string;
  items: ServiceItem[];
  stripTitle?: string;
}

const ServicesPortfolio: React.FC<ServicesPortfolioProps> = ({
  heading,
  subheading,
  items,
  stripTitle,
}) => {
  return (
    <>
      <section className={styles.sectionWrapper}>
        <div className="container-lg">
          <div className={styles.headingBlock}>
            <h4 className={styles.heading}>{heading}</h4>
            <p className={styles.subheading}>{subheading}</p>
          </div>

          <div className="row mt-4">
            {items.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-12" key={index}>
                <div className={styles.card}>
                  <div className={styles.iconWrap}>
                    <Image
                      src={item.icon}
                      alt={item.title}
                      width={110}
                      height={110}
                      className={styles.icon}
                    />
                  </div>

                  <h5 className={styles.cardTitle}>{item.title}</h5>
                  <p className={styles.cardDesc}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {stripTitle && (
        <div className={styles.pinkStrip}>
          <div className="container">
            <h3 className={styles.stripTitle}>{stripTitle}</h3>
          </div>
        </div>
      )}
    </>
  );
};

export default ServicesPortfolio;
